var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4564 26.9309V34.6893L41.2793 24.8663H33.5207C32.3825 24.8663 31.4564 25.7924 31.4564 26.9309Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4745 0H11.1153C8.62004 0 6.59009 2.02995 6.59009 4.5255V30.8848C6.59009 33.38 8.62004 35.4099 11.1153 35.4099H28.9955V27.5023H14.4103C13.7307 27.5023 13.1798 26.9514 13.1798 26.2718C13.1798 25.5925 13.7307 25.0413 14.4103 25.0413H29.4102C30.1276 23.4872 31.6997 22.4054 33.5207 22.4054H42V4.5255C42 2.02995 39.9701 0 37.4745 0ZM18.3641 7.90768H30.226C30.9053 7.90768 31.4565 8.45883 31.4565 9.13815C31.4565 9.81779 30.9053 10.3686 30.226 10.3686H18.3641C17.6845 10.3686 17.1337 9.81779 17.1337 9.13815C17.1337 8.45883 17.6845 7.90768 18.3641 7.90768ZM34.1795 18.9354H14.4103C13.7307 18.9354 13.1798 18.3846 13.1798 17.705C13.1798 17.0257 13.7307 16.4745 14.4103 16.4745H34.1795C34.8591 16.4745 35.41 17.0257 35.41 17.705C35.41 18.3846 34.8591 18.9354 34.1795 18.9354Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.226 37.8708H11.1152C7.26297 37.8708 4.12912 34.737 4.12912 30.8847V6.60828C1.81879 6.80983 0 8.75359 0 11.1152V37.4745C0 39.97 2.02995 42 4.5255 42H30.8848C33.38 42 35.4099 39.97 35.4099 37.4745V34.2156L32.8362 36.7897C32.1389 37.487 31.2119 37.8708 30.226 37.8708Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.d45d8c5a92c1bacc163199cdf81286a4.svg";
export { ForwardRef as ReactComponent };